/*
 * @Description: 跳转方法
 * @LastEditors: wjx
 * @Date: 2021-01-19 13:15:26
 */
import { projectV2 } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';
import store from '@/store';
import router from '@/router';

/**
 * @description: 健全项目详情
 * @param {number} projectId 项目ID
 * @param {number} isComplete // 0未完成 >=当前月, 1已完成 <当前月, 2跳过条件判断返回全部
 * @return {object} 项目详情
 */
const improveProjectInformation = async (projectId, isComplete = 0) => {
  if (!projectId) {
    throw new Error('need projectId');
  }
  const {
    data: {
      data: [
        {
          list: [detail]
        }
      ]
    }
  } = await projectV2.projectV2List({
    projectId,
    isComplete
  });
  await store.dispatch('syncProjectInfo', detail);
  return Promise.resolve(detail);
};

/**
 * @description: 跳转到确认任务
 * @param {object} row 当前数据
 * @return {void}
 */
const toAssign = async row => {
  let { projectId, taskDt } = row;
  await improveProjectInformation(projectId);
  const fullRoute = router.resolve({
    path: '/assign/index',
    query: {
      id: projectId,
      taskDt
    }
  });
  window.open(fullRoute.href, '_blank');
};

/**
 * @description: 跳转到记录详情页
 * @param {object} row 当前数据
 * @return {void}
 */
const toRecord = async row => {
  let {
    projectId,
    fullName = '',
    phone = '',
    dateRangeStart,
    dateRangeEnd
  } = row;
  await improveProjectInformation(projectId);
  const fullRoute = router.resolve({
    path: '/record/index',
    query: {
      activeTask: 'recordList',
      id: projectId,
      fullName,
      phone,
      dateRangeStart: dateFormat(dateRangeStart, 'YYYY-MM'),
      dateRangeEnd: dateFormat(dateRangeEnd, 'YYYY-MM')
    }
  });
  window.open(fullRoute.href, '_blank');
};

export { toRecord, toAssign };
